import { Paper } from '@mantine/core';
import Image from 'next/image';

export default function LoginTemplate({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-screen bg-dark-900 flex justify-between relative overflow-hidden">
      {/* Glow effect behind form container */}
      <div
        className="absolute right-0 top-1/2 transform -translate-y-1/2 w-[800px] h-[900px] pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 600px 750px, rgba(19, 17, 153, 0.4) 0%, rgba(19, 17, 153, 0.2) 30%, rgba(19, 17, 153, 0.1) 50%, transparent 70%)',
          filter: 'blur(60px)',
        }}
      />
      <div
        className="hidden w-full min-h-screen h-full relative sm:flex"
        style={{ maxWidth: 'calc(100% - 450px)' }}
      />
      <Paper
        className="h-screen w-full flex flex-col max-w-full p-8 gap-4 justify-between sm:max-w-[450px] overflow-y-auto"
        radius={0}
        style={{
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
        }}
      >
        <div className="flex justify-center items-center pt-8">
          <Image src="/logo/agento-logo-white.png" alt="" width={280} height={140} priority />
        </div>
        <div>{children}</div>
        <div className="invisible" />
      </Paper>
    </div>
  );
}
